export default __webpack_public_path__ + "static/media/homebanner-1.0547654d.jpg";